import styled from 'styled-components'

export const WrapperComponent = styled.div`
    overflow-y: auto;
    height: 100%;

    ::-webkit-scrollbar {
        width: 4px;
        background-color: var(--gray-700);
    }

    ::-webkit-scrollbar-track {
        background: var(--gray-200);
    }

    ::-webkit-scrollbar-thumb {
        background: var(--gray-600);
    }

    ::-webkit-scrollbar-thumb:hover {
        background: var(--gray-700);
    }
`

export const Wrapper = styled.div`
    font-family: SourceSansPro-Semibold, Arial, Helvetica Neue, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;
    display: grid;
    height: 100%;
    grid-template-rows: ${props => props.templateRow};
    grid-template-columns: ${props => props.templateCol};
    grid-template-areas: ${props => props.templateAreas};
    color: var(--gray-800);
    div {
        h3 {
            font-size: 10px;
            line-height: 12px;
            width: fit-content;
            color: var(--gray-800);
        }

        p {
            font-size: 24px;
            line-height: 24px;
            color: var(--gray-800);
            margin-bottom: 4px;
            span {
                font-size: 16px;
                margin-left: 4px;
            }
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 100%;
            padding-right: 1px;
        }
    }
`
